var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickRepliesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16668 10.0022V10.0003C2.16668 7.9228 2.99197 5.93036 4.46101 4.46132C5.1884 3.73393 6.05194 3.15693 7.00232 2.76327C7.95271 2.36961 8.97132 2.16699 10 2.16699C12.0775 2.16699 14.07 2.99229 15.539 4.46132C17.008 5.93036 17.8333 7.9228 17.8333 10.0003C17.8333 12.0779 17.008 14.0703 15.539 15.5393C14.07 17.0084 12.0775 17.8337 10 17.8337H2.50001H2.48949L2.47898 17.8341C2.41298 17.8369 2.34764 17.82 2.29126 17.7856C2.23733 17.7526 2.19392 17.7051 2.16602 17.6485C2.14315 17.59 2.13729 17.5261 2.14921 17.4642C2.16158 17.4 2.19258 17.3408 2.23832 17.2941C2.23863 17.2938 2.23894 17.2935 2.23925 17.2932L3.90356 15.6289L4.22478 15.3077L3.93575 14.9572C2.78569 13.5627 2.15983 11.8098 2.16668 10.0022ZM10 17.167H10.0004C11.6584 17.1657 13.2646 16.5896 14.5454 15.5368C15.8263 14.484 16.7025 13.0197 17.0247 11.3934C17.347 9.767 17.0954 8.07922 16.3128 6.61756C15.5303 5.1559 14.2651 4.0108 12.7329 3.37735C11.2007 2.7439 9.49626 2.66129 7.90999 3.14359C6.32372 3.6259 4.95374 4.64328 4.03346 6.0224C3.11319 7.40152 2.69955 9.05706 2.86302 10.707C3.02647 12.3566 3.75671 13.8985 4.92936 15.0701C4.99106 15.1325 5.02567 15.2167 5.02567 15.3045C5.02567 15.3923 4.99099 15.4766 4.92919 15.539C4.92904 15.5392 4.92889 15.5393 4.92874 15.5395L4.15479 16.3134L3.30124 17.167H4.50834H10Z",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 6.38281L8 10.3828H12L9.33333 14.3828",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickRepliesIcon);
export default __webpack_public_path__ + "static/media/quick_replies_icon.b62e7670.svg";
export { ForwardRef as ReactComponent };